import theme from './themes/mainTheme';

import {css} from 'styled-components'

export const mixins = {
    ease: (ratio = 1) => css`
      transition-duration: ${theme.tGeneric * ratio}s;
      transition-timing-function: ${theme.tfStandard};
`,
    pseudoToBlock: (...args) => css`
      display: block;
      content: '';
`,
    stretch: (...args) => css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: auto;
      width: auto;
`,
    fitBg: (...args) => css`
      background-size: cover;
      background-position: center;
 `,
};

export const media = Object.keys(theme.breakpoints).reduce((acc, label) => {
    acc[label] = (...args) => css`
    @media (max-width: ${theme.breakpoints[label]}px) {
      ${css(...args)}
    }
  `;

    return acc
}, {});